import { useState } from 'react';
import { SourceDetail } from '../apiTypes';
import { readSource } from '../functionApi';
import { useAxiosInterceptor } from '../wrappers';

export function useSourceDetail(
  reportId?: string,
  componentId?: string,
  elementId?: string
) {
  useAxiosInterceptor();
  const [cache, setCache] = useState<Record<string, SourceDetail>>({});
  const [loading, setLoading] = useState<Record<string, boolean>>({});
  const [error, setError] = useState<Record<string, string>>({});

  const fetchDetail = async (sourceId: string) => {
    if (!reportId || !componentId || !elementId) return;
    if (cache[sourceId] || loading[sourceId]) return;

    setLoading((prev) => ({ ...prev, [sourceId]: true }));
    try {
      const data = await readSource(reportId, componentId, elementId, sourceId);
      setCache((prev) => ({ ...prev, [sourceId]: data }));
      setError((prev) => ({ ...prev, [sourceId]: '' }));
    } catch (err) {
      setError((prev) => ({ ...prev, [sourceId]: 'Errore nel caricamento del contenuto' }));
    } finally {
      setLoading((prev) => ({ ...prev, [sourceId]: false }));
    }
  };

  return { cache, loading, error, fetchDetail };
}
